import React from 'react';
import { useSelector } from 'react-redux';

import { LineNumbers } from '../Types/Types';
import { RootState } from '../redux/store';

type Props = Readonly<{
    lines: LineNumbers[];
    stakes?: number[];
    bankers?: number[];
    permutations?: number[];
    betType?: 'simple';
    sequenceId?: number;
}>;

function HiddenInputs({ lines, stakes, bankers, permutations, betType, sequenceId }: Props) {
    const { lottery } = useSelector((state: RootState) => state.playStore);
    const inputs: [string, string][] = [
        ['lottery', lottery.slug],
        ['lines', JSON.stringify(lines)],
    ];

    if (stakes != null) {
        inputs.push(['stakes', JSON.stringify(stakes)]);
    }

    if (bankers != null) {
        inputs.push(['bankers', JSON.stringify(bankers)]);
    }

    if (permutations != null) {
        inputs.push(['permutations', JSON.stringify(permutations)]);
    }

    if (betType != null) {
        inputs.push(['bet_type', betType]);
    }

    if (sequenceId != null) {
        inputs.push(['sequence_id', String(sequenceId)]);
    }

    return (
        <>
            {inputs.map(([name, value]) => (
                <input key={name} type="hidden" name={name} value={value} />
            ))}
        </>
    );
}

export default HiddenInputs;
